/**
 * Normalize a raw radio value (0=significant, 1=some, 2=minimal)
 * into "need points" where higher = greater need.
 * @param {number} rawAnswer - Raw answer (0, 1, or 2)
 * @returns {number} Need points (0, 1, or 2)
 */
export function toNeedPoints(rawAnswer) {
  if (![0, 1, 2].includes(rawAnswer)) throw new Error("Answer must be 0,1,2");
  return 2 - rawAnswer;
}

/** 
 * Sum normalized answers into a 0–12 "need score".
 * @param {number[]} rawAnswers - Array of raw answers (0, 1, or 2)
 * @returns {number} Need score (0-12, higher = greater need)
 */
export function triageToNeedScore(rawAnswers) {
  return rawAnswers.reduce((sum, a) => sum + toNeedPoints(a), 0);
}

/**
 * Thresholds for recommended path based on NEED score.
 * @param {number} needScore - Need score (0-12, higher = greater need)
 * @returns {"NC_ONLY" | "NC_WITH_SUPPORTS" | "BESPOKE"}
 */
export function scoreToPath(needScore) {
  if (needScore <= 2) return "NC_ONLY";            // 0–2
  if (needScore <= 6) return "NC_WITH_SUPPORTS";   // 3–6
  return "BESPOKE";                                 // 7–12
}

/**
 * Convert path enum to friendly display string
 * @param {"NC_ONLY" | "NC_WITH_SUPPORTS" | "BESPOKE"} path
 * @returns {string} Friendly display text
 */
export function pathLabel(path) {
  if (path === "NC_ONLY") return "National Curriculum (no additional supports required)";
  if (path === "NC_WITH_SUPPORTS") return "National Curriculum with supports/interventions";
  return "Bespoke Curriculum (Engagement Model / Pre-key stage)";
}

/**
 * Ensure need score is computed correctly, handling legacy data
 * @param {Object} meta - Student plan metadata
 * @returns {number} Need score (0-12)
 */
export function ensureNeedScore(meta) {
  if (typeof meta?.decisionScore === "number") return meta.decisionScore;
  if (Array.isArray(meta?.triageAnswers)) {
    const raw = meta.triageAnswers.map((x) => Number(x.raw ?? x.score ?? 1));
    return triageToNeedScore(raw);
  }
  return 0;
}



